import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface ConfirmOrLeave {
  canDeactivate: () => boolean | Promise<boolean> | Observable<boolean>;
}

export const confirmOrLeaveGuard: CanDeactivateFn<ConfirmOrLeave> =
   (component) => {
    return component.canDeactivate
      ? component.canDeactivate()
      : true;
  };